import classNames from "classnames";
import { PropsWithChildren } from "react";

export const Column = ({ children }: PropsWithChildren) => <div className="min-w-0 flex-1 flex flex-col gap-10">{children}</div>;

export const Row = ({ children }: PropsWithChildren) => <div className="flex flex-col lg:flex-row gap-10 lg:gap-20">{children}</div>;

export const Container = ({ className, children }: { className?: string } & PropsWithChildren) => (
  <div className={classNames("h-full flex flex-col w-full mx-auto max-w-[500px] lg:max-w-[800px] px-6 lg:px-0 my-10 lg:my-16", className)}>
    {children}
  </div>
);

export const NarrowContainer = ({ className, children }: { className?: string } & PropsWithChildren) => (
  <div className={classNames("h-full lg:mx-auto lg:w-[500px]", className)}>{children}</div>
);

export const NavBarMenuOverlay = ({ className, children }: { className?: string } & PropsWithChildren) => (
  <div className={classNames("absolute top-[80px] border-t border-brand-grey-light bg-white rounded-b-lg overflow-hidden shadow-md", className)}>
    {children}
  </div>
);
